// Components
import ListboxInput from 'components/inputs/listbox'
// Data
import { local } from 'data/lib/local-json'
import propertyReportService from "data/reports-property"
import React, { FC, useState } from "react"
// Styles
import { ButtonWithPress_s, Button_s, Label_s } from "styles/app-styles"
import { ReportForm_s } from "styles/report-styles"

const CommercialInputAssumptions: FC = (props) => {
  const propertyType = local('property_type', null);
  const multRrReport = { label: 'Multifamily Rent Roll', value: 'mult_rent_roll' }

  const objectTypeOptions = [
    { label: 'Area Measure', value: 'area_measure' },
    { label: 'Credit & Vacancy Loss', value: 'credit_and_vacancy_loss' },
    { label: 'Downtime', value: 'downtime' },
    { label: 'Free Rent', value: 'free_rent' },
    { label: 'Increase', value: 'increase' },
    { label: 'Inflation', value: 'inflation' },
    { label: 'L.C.', value: 'lc' },
    { label: 'Line Item', value: 'line_items' },
    { label: 'Market Lease', value: 'market_lease' },
    { label: 'Named Recovery', value: 'named_recovery' },
    { label: 'O.C.', value: 'oc' },
    { label: 'Payout', value: 'payout' },
    { label: 'Property', value: 'property' },
    { label: 'Recovery Group', value: 'recovery_group' },
    { label: 'Recovery Pool', value: 'recovery_pool' },
    { label: 'Renewal Probability', value: 'renewal_probability' },
    { label: 'Rent', value: 'rent' },
    { label: 'Report Tag', value: 'report_tag' },
    { label: 'Rooms', value: 'rooms' },
    { label: 'Tenant Contributions', value: 'tenant_contribution' },
    { label: 'Tenant Group', value: 'tenant_group' },
    { label: 'T.I.', value: 'ti' },
    { label: 'Valuation Settings', value: 'valuation_settings'}
  ]

  if (propertyType === 'Mixed-Use'){
    objectTypeOptions.splice(8, 0, multRrReport)
    objectTypeOptions.splice(19, 1)
  }

  const [selected_reports, setReports] = useState<any>(objectTypeOptions.map(option => option.value));

  function submit():void {
    propertyReportService.propertyReport({
      report: 'input_assumptions',
      params: {
        selected_reports
      }
    })
  }

  return (
    <div>
      <ButtonWithPress_s primary onClick={submit} style={{marginBottom: 20}} disabled={selected_reports.length === 0}>Run Report</ButtonWithPress_s>
      <ReportForm_s>
        <div style={{width: '200px'}}>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10}}>
            <Label_s>Object Type</Label_s>
            <Button_s onClick={()=>{ selected_reports.length === objectTypeOptions.length ? setReports([]) : setReports(objectTypeOptions.map(option => option.value))}}>
              {selected_reports.length === objectTypeOptions.length ? 'Deselect All' : 'Select All'}
            </Button_s>
          </div>
          <ListboxInput field="valuationPeriod" value={selected_reports} options={objectTypeOptions} persist={(field:string, val:string)=>setReports(val)} multiple={true} />
        </div>
      </ReportForm_s>
    </div>
  )
}

export default CommercialInputAssumptions
